export default {
  loading: false,
  ready: false,
  error: false,
  table: 'courses'
}
